const PoiType = {
  poi_type_masterplan_info: 2,
  poi_type_masterplan: 3,
  poi_type_plot: 4,
  poi_type_building: 5,
  poi_type_building_info: 12,
  poi_type_apartment: 6,
  poi_type_apartment_info: 13,
  poi_type_building_apartment_view: 7,
  poi_type_masterplan_camera_view: 8,
  poi_type_streetview_point: 9,
  poi_type_streetview_start_point: 10
}

const MediaType = {
  poi_title: 1,
  poi_image: 2,
  project_title_image: 3,
  project_text_description: 4,
  menu_item_title: 5,
  media_gallery: 6,
  poi_unity_component_data: 10,
  description: 11,
  image: 12,
  level: 13,
  level_order: 14,
  card_type: 15,
  unity_serialize_component: 16,
  unity_link_component: 17,
  poi_data: 18,
  unity_language_config: 19,
  poi_image_dzi: 21,
  project_config: 22,
  project_title: 23
}

// const MediaType = {
//   poi_title: 1,
//   poi_image: 2,
//   project_title_image: 3,
//   project_text_description: 4,
//   menu_item_title: 5,
//   media_gallery: 6,
//   poi_unity_component_data: 10,
//   description: 11,
//   image: 12,
//   level: 13,
//   level_order: 14,
//   card_type: 15,
//   unity_serialize_component: 16,
//   unity_link_component: 17,
//   poi_data: 18,
//   unity_language_config: 19,
//   poi_image_dzi: 21,
//   project_title: 23
// }

const MediaAssetType = {
  image_path: 1,
  image_url: 2
}

const lang = {
  1: { id: 1, name: 'English' },
  2: { id: 2, name: 'Español' },
  3: { id: 3, name: 'Deutsch' },
  4: { id: 4, name: 'Français' },
  5: { id: 5, name: 'Arabic اَلْعَرَبِيَّةُ' },
  6: { id: 6, name: 'Srpski latinica' },
  7: { id: 7, name: 'Српски ћирилица' }
}

const filters = {
  1: { id: 1, name: 'Status' },
  2: { id: 2, name: 'Area' },
  3: { id: 3, name: 'Floors' },
  4: { id: 4, name: 'Price' },
  5: { id: 5, name: 'Apartment Type' },
  6: { id: 6, name: 'Orientation' },
  7: { id: 7, name: 'All apartments' }
}

const roles = {
  1: { id: 1, name: 'super_admin' },
  2: { id: 2, name: 'project_admin' },
  3: { id: 3, name: 'project_editor' },
  4: { id: 4, name: 'user' }
}

const AppContext = {
  context_masterplans: 1,
  context_child_masterplans: 2,
  context_buildings: 3,
  context_apartments: 4,
  global: 5
}

const FieldEditorType = {
  plainText: 'plain-text',
  selectBoxSingleValue: 'select-box-single-value'
}

const ApartmentStatus = {
  apartment_status_available: 1,
  apartment_status_reserved: 2,
  apartment_status_sold: 3,
  apartment_status_unavailable: 4
}

export default {
  PoiType,
  MediaType,
  MediaAssetType,
  lang,
  filters,
  roles,
  AppContext,
  FieldEditorType,
  ApartmentStatus
}
